// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewError_wrapper__u6ljH","backLink":"ViewError_backLink__LX9b2"};